<template>
  <div class="w-full">
    <div class="group flex items-center justify-between w-full rounded-md transition-colors"
    :class="[
          isSelected 
            ? 'text-primary bg-primary-50' 
            : 'text-text-main hover:bg-surface'
        ]">
      
      <button
        type="button"
        @click.prevent.stop="handleSelect"
        class="flex-1 px-2 py-2 text-sm font-medium text-left truncate rounded-l-md outline-none"
      >
        <span>{{ item.title }}</span>
        <span v-if="item.count" class="text-xs opacity-70 ml-1">({{ item.count }})</span>
      </button>
      
      <button
        v-if="item.children && item.children.length"
        type="button"
        @click.prevent.stop="handleToggle"
        class="px-2 flex items-center justify-center transition-all rounded-r-md outline-none h-[36px]"
        :class="[
          isSelected 
            ? 'hover:bg-primary-100' 
            : 'hover:bg-black/5'
        ]"
      >
        <x-icons name="expand_more" class="text-lg transition-transform duration-200"
          :class="{
            'rotate-180': isExpanded,
            'text-primary': isSelected,
            'text-text-secondary': !isSelected
          }" />
      </button>
      
      <div v-else class="w-9"></div> 
    </div>
    
    <div v-if="isExpanded && item.children" class="pl-4 space-y-1 mt-1 border-l border-border/50 ml-4">
      <CategoryTreeItem
        v-for="child in item.children"
        :key="child.key"
        :item="child"
        :expanded-keys="expandedKeys"
        :selected-keys="selectedKeys"
        @toggle="$emit('toggle', $event)"
        @select="$emit('select', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryTreeItem',
  props: ['item', 'expandedKeys', 'selectedKeys'],
  emits: ['toggle', 'select'],
  computed: {
    isExpanded() { 
      return this.expandedKeys.includes(this.item.key); 
    },
    isSelected() { 
      return this.selectedKeys.includes(this.item.key); 
    }
  },
  methods: {
    handleToggle(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.$emit('toggle', this.item);
    },
    handleSelect(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.$emit('select', this.item);
    }
  }
}
</script>